import {Map as OlMap, View} from 'ol';
import {mapUnitWMSLayer, wmtsLayer} from "./map";
import {removeReadyStoreKey, updateReadyStore} from "@manaakiwhenua/frag-svelte/src/print-util/readyStore";

/**
 * Svelte action. See https://svelte.dev/docs#use_action
 */
export function lucMap(target, {extent, mapBaseUrl, wmsBaseUrl, nzcu, readyStore}) {
    const padding = [5, 5, 5, 5];

    const view = new View({
        center: [ 1552948.7293751452, 5459807.526447211 ],
        zoom: 5.6,
        projection: "EPSG:2193"
    });

    let currentExtent = extent || [ 649980.3873042655, 4539084.891307448, 2486911.7199041513, 6376016.223907334 ];

    view.on('change', () => {
        console.log(view.getCenter(), view.getZoom());
    });

    const baseLayer = wmtsLayer({
        mapLayersURL: mapBaseUrl,
        layerName: 'topobasemap_notext_grey',
        hdpi: true
    });

    function createLucLayer(nzcuCode) {
        return mapUnitWMSLayer({
            hdpi: true,
            map: '/opt/mapserver/mapfiles/lri.map',
            layers: 'lri_nzcu',
            url: wmsBaseUrl,
            extraParams: {
                nzcu: nzcuCode
            }
        })
    }

    let currentNzcu = nzcu;
    let lucLayer = createLucLayer(nzcu);

    const contextLayer = wmtsLayer({
        mapLayersURL: mapBaseUrl,
        layerName: 'text',
        hdpi: true
    });

    const map = new OlMap({
        controls: [],
        projection: "EPSG:2193",
        interactions: [],
        layers: [
            baseLayer,
            lucLayer,
            contextLayer
        ],
        target,
        view
    })

    console.log('luc-map not ready')
    updateReadyStore(readyStore, map, false);

    map.on('rendercomplete', () => {
        console.log('luc-map ready')
        updateReadyStore(readyStore, map, true)
    })

    const fit = () => {
        view.fit(
            currentExtent || [ -420480, 4423680, 3799680, 6464320 ],
            { size: map.getSize(), padding }
        );
    };
    map.on('change:size', fit);
    fit();

    return {
        update(options) {
            const {
                extent, nzcu
            } = options;

            console.log(options)
            currentExtent = extent;

            if (nzcu && nzcu !== currentNzcu) {
                currentNzcu = nzcu;
                lucLayer = createLucLayer(nzcu);
                map.getLayers().setAt(1, lucLayer);
            }

            map.updateSize();
            fit();
        },
        destroy() {
            console.log('map.dispose()');
            removeReadyStoreKey(readyStore, map);
            map.dispose();
        }
    }
}
